/* eslint-disable @tencent/i18next/no-literal-string */
import i18n from '@i18next/i18n';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
const EnDay = {
    1: 'Monday',
    2: 'Tuesday',
    3: 'Wednesday',
    4: 'Thursday',
    5: 'Friday',
    6: 'Saturday',
    7: 'Sunday',
};
const ZhDay = {
    0: '日',
    1: '一',
    2: '二',
    3: '三',
    4: '四',
    5: '五',
    6: '六',
};
const EnMonth = {
    1: 'January',
    2: 'February',
    3: 'March',
    4: 'April',
    5: 'May',
    6: 'June',
    7: 'July',
    8: 'August',
    9: 'September',
    10: 'October',
    11: 'November',
    12: 'December',
};
const SimEnMonth = {
    1: 'Jan',
    2: 'Feb',
    3: 'Mar',
    4: 'Apr',
    5: 'May',
    6: 'Jun',
    7: 'Jul',
    8: 'Aug',
    9: 'Sep',
    10: 'Oct',
    11: 'Nov',
    12: 'Dec',
};

interface DatetimeType {
    year: number;
    month: number;
    date: number;
    day: number;
    hour: number;
    min: number;
    sec: number;
}

const prefixZero = (num: number): string => (Array(2).join('0') + num).slice(-2);

const getFormatDatetime1 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        return `${datetime.year}/${datetime.month}/${datetime.date}`;
    }
    return `${datetime.month}/${datetime.date}/${datetime.year}`;
};

const getFormatDatetime2 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        if (browser.isMac) {
            return `${datetime.year}年${datetime.month}月${datetime.date}日 ${EnDay[datetime.day]}`;
        }
        return `${datetime.year}年${datetime.month}月${datetime.date}日`;
    }
    return `${EnDay[datetime.day]}, ${EnMonth[datetime.month]} ${datetime.date}, ${datetime.year}`;
};

const getFormatDatetime3 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        return `${datetime.year}年${datetime.month}月${datetime.date}日星期${ZhDay[datetime.day]}`;
    }
    return `${datetime.date} ${EnMonth[datetime.month]} ${datetime.year}`;
};

const getFormatDatetime4 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        return `${datetime.year}年${datetime.month}月${datetime.date}日星期${ZhDay[datetime.day]}`;
    }
    return `${EnMonth[datetime.month]} ${datetime.date}, ${datetime.year}`;
};

const getFormatDatetime5 = (datetime: DatetimeType, lang: string): string => {
    const year = datetime.year.toString().slice(2);
    if (lang === 'ea') {
        return `${datetime.year}/${datetime.month}/${datetime.date}`;
    }
    return `${datetime.date}-${SimEnMonth[datetime.month]}-${year}`;
};

const getFormatDatetime6 = (datetime: DatetimeType, lang: string): string => {
    const year = datetime.year.toString().slice(2);
    if (lang === 'ea') {
        return `${datetime.year}年${datetime.month}月`;
    }
    return `${EnMonth[datetime.month]} ${year}`;
};

const getFormatDatetime7 = (datetime: DatetimeType, lang: string): string => {
    const year = datetime.year.toString().slice(2);
    if (lang === 'ea') {
        return `${year}.${datetime.month}.${datetime.date}`;
    }
    return `${SimEnMonth[datetime.month]}-${year}`;
};

const getFormatDatetime8 = (datetime: DatetimeType, lang: string): string => {
    const am = datetime.hour <= 12;
    if (lang === 'ea') {
        return `${datetime.year}年${datetime.month}月${datetime.date}日${am ? datetime.hour : datetime.hour - 12}时${
            datetime.min
        }分`;
    }
    return `${datetime.month}/${datetime.date}/${datetime.year} ${am ? datetime.hour : datetime.hour - 12}:${prefixZero(datetime.min)} ${am ? 'AM' : 'PM'}`;
};

const getFormatDatetime9 = (datetime: DatetimeType, lang: string): string => {
    const am = datetime.hour <= 12;
    if (lang === 'ea') {
        return `${datetime.year}年${datetime.month}月${datetime.date}日星期${ZhDay[datetime.day]}${
            am ? datetime.hour : datetime.hour - 12
        }时${datetime.min}分${datetime.sec}秒`;
    }
    return `${datetime.month}/${datetime.date}/${datetime.year} ${am ? datetime.hour : datetime.hour - 12}:${prefixZero(datetime.min)}:${prefixZero(datetime.sec)} ${am ? 'AM' : 'PM'}`;
};

const getFormatDatetime10 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        return `${datetime.hour}:${datetime.min}`;
    }
    return `${datetime.hour}:${prefixZero(datetime.min)}`;
};

const getFormatDatetime11 = (datetime: DatetimeType, lang: string): string => {
    if (lang === 'ea') {
        return `${datetime.hour}:${datetime.min}:${datetime.sec}`;
    }
    return `${datetime.hour}:${prefixZero(datetime.min)}:${prefixZero(datetime.sec)}`;
};

const getFormatDatetime12 = (datetime: DatetimeType, lang: string): string => {
    const am = datetime.hour <= 12;
    if (lang === 'ea') {
        return `${am ? '上午' : '下午'}${am ? datetime.hour : datetime.hour - 12}时${datetime.min}分`;
    }
    return `${am ? datetime.hour : datetime.hour - 12}:${prefixZero(datetime.min)} ${am ? 'AM' : 'PM'}`;
};

const getFormatDatetime13 = (datetime: DatetimeType, lang: string): string => {
    const am = datetime.hour <= 12;
    if (lang === 'ea') {
        return `${am ? '上午' : '下午'}${am ? datetime.hour : datetime.hour - 12}时${datetime.min}分${datetime.sec}秒`;
    }
    return `${am ? datetime.hour : datetime.hour - 12}:${prefixZero(datetime.min)}:${prefixZero(datetime.sec)} ${
        am ? 'AM' : 'PM'
    }`;
};

const getFormatDatetimeyyyy = (datetime: DatetimeType, lang: string): string => `${datetime.year}${lang === 'ea' ? '年' : ''}`;

const datetimeType = {
    1: getFormatDatetime1,
    2: getFormatDatetime2,
    3: getFormatDatetime3,
    4: getFormatDatetime4,
    5: getFormatDatetime5,
    6: getFormatDatetime6,
    7: getFormatDatetime7,
    8: getFormatDatetime8,
    9: getFormatDatetime9,
    10: getFormatDatetime10,
    11: getFormatDatetime11,
    12: getFormatDatetime12,
    13: getFormatDatetime13,
    yyyy: getFormatDatetimeyyyy,
    FigureOut: getFormatDatetime1,
};

function getLanguageByI18n() {
    if (i18n.language === 'zh-CN' || i18n.language === 'zh-HK' || i18n.language === 'zh') {
        return 'ea';
    }
    return 'latin';
}

const getCurrentFormatTime = (type, lang, curTime: Date) => {
    const language = lang || getLanguageByI18n();
    if (type) {
        const time = curTime;
        const datetime = {
            year: time.getFullYear(),
            month: time.getMonth() + 1,
            date: time.getDate(),
            day: time.getDay(),
            hour: time.getHours(),
            min: time.getMinutes(),
            sec: time.getSeconds(),
        };
        return datetimeType[type]?.(datetime, language);
    }
    return null;
};
export enum DatetimeFieldType {
    DATETIME_1 = 'datetime1',
    DATETIME_2 = 'datetime2',
    DATETIME_3 = 'datetime3',
    DATETIME_4 = 'datetime4',
    DATETIME_5 = 'datetime5',
    DATETIME_6 = 'datetime6',
    DATETIME_7 = 'datetime7',
    DATETIME_8 = 'datetime8',
    DATETIME_9 = 'datetime9',
    DATETIME_10 = 'datetime10',
    DATETIME_11 = 'datetime11',
    DATETIME_12 = 'datetime12',
    DATETIME_13 = 'datetime13',
    DATETIME_YYYY = 'datetimeyyyy',
    DATETIME_FIGUREOUT = 'datetimeFigureOut',
}
export default getCurrentFormatTime;
